module.exports = __webpack_public_path__ + "img/hp-basic-disabled.aa611502.png";